export const RESET = 'SETTLEMENT_LIST_RESET'
export const SET_ITEMS = 'SETTLEMENT_LIST_SET_ITEMS'
export const SET_ERROR = 'SETTLEMENT_LIST_SET_ERROR'
export const SET_SELECT_ITEMS = 'SETTLEMENT_LIST_SET_SELECT_ITEMS'
export const SET_VIEW = 'SETTLEMENT_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'SETTLEMENT_LIST_TOGGLE_LOADING'
